const translations = {
  en: {
    withdrawUsing: 'Withdraw using',
    cryptoAddress: 'Crypto Address',
    currency: 'Currency',
    amount: 'Amount',
    payoutLimits: 'PayoutLimits: Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    commentsOptional: 'Comments (Optional)',
    networkWarning: 'Only {payoutId} can be sent to provided address from the selected network.  Payouts of other crypto currencies or networks will be lost.',
    providerFee: 'fee for this payout method charged by provider',
    noWithdrawFee: 'No withdraw fee charge by provider.',
    back: 'BACK',
    submit: 'SUBMIT',
    warning: 'Warning',
    amountRequired: 'Amount required',
    withdrawalStatus: 'Withdrawal Status',
    amountNotPermitted: 'amount not permitted, please check your withdrawal balance',
  },
  es: {
    withdrawUsing: 'Retirar usando',
    cryptoAddress: 'Dirección Cripto',
    currency: 'Moneda',
    amount: 'Monto',
    payoutLimits: 'Límites de retiro: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin Límite',
    commentsOptional: 'Comentarios (Opcional)',
    networkWarning: 'Solo {payoutId} puede ser enviado a la dirección proporcionada desde la red seleccionada. Los retiros de otras criptomonedas o redes se perderán.',
    providerFee: 'de comisión por este método de retiro cobrada por el proveedor',
    noWithdrawFee: 'Sin comisión de retiro cobrada por el proveedor.',
    back: 'ATRÁS',
    submit: 'ENVIAR',
    warning: 'Advertencia',
    amountRequired: 'Monto requerido',
    withdrawalStatus: 'Estado del Retiro',
    amountNotPermitted: 'Monto no permitido, por favor verifique su saldo disponible para retiro',
  },
  pt: {
    withdrawUsing: 'Sacar usando',
    cryptoAddress: 'Endereço Cripto',
    currency: 'Moeda',
    amount: 'Valor',
    payoutLimits: 'Limites de saque: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem Limite',
    commentsOptional: 'Comentários (Opcional)',
    networkWarning: 'Somente {payoutId} pode ser enviado ao endereço fornecido da rede selecionada. Saques de outras criptomoedas ou redes serão perdidos.',
    providerFee: 'de taxa por este método de saque cobrada pelo provedor',
    noWithdrawFee: 'Sem cobrança de taxa de saque pelo provedor.',
    back: 'VOLTAR',
    submit: 'ENVIAR',
    warning: 'Aviso',
    amountRequired: 'Valor obrigatório',
    withdrawalStatus: 'Status do Saque',
    amountNotPermitted: 'Valor não permitido, por favor verifique seu saldo disponível para saque',
  },
}

export default translations
